export const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@$!%*#?&])[A-Za-z\d\W_@$!#%*?&]{6,20}$/

const passwordSpecialCharacters = '_@$!%*#?&'
const passwordLowercaseCharacters = 'abcdefghijklmnopqrstuvwxyz'
const passwordUppercaseCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const passwordDigitCharacters = '0123456789'
const passwordAllCharacters = `${passwordLowercaseCharacters}${passwordUppercaseCharacters}${passwordDigitCharacters}${passwordSpecialCharacters}`

const getSecureRandomIndex = (max: number) => {
  if (max <= 0) {
    return 0
  }

  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    const values = new Uint32Array(1)
    globalThis.crypto.getRandomValues(values)
    return values[0] % max
  }

  return Math.floor(Math.random() * max)
}

const randomCharacterFrom = (source: string) => source.charAt(getSecureRandomIndex(source.length))

const shuffleCharacters = (characters: string[]) => {
  const next = [...characters]
  for (let index = next.length - 1; index > 0; index -= 1) {
    const swapIndex = getSecureRandomIndex(index + 1)
    ;[next[index], next[swapIndex]] = [next[swapIndex], next[index]]
  }
  return next
}

export const isValidPassword = (value: string) => passwordPattern.test(String(value ?? '').trim())

export const generateRandomPassword = () => {
  const characters = [
    randomCharacterFrom(passwordLowercaseCharacters),
    randomCharacterFrom(passwordUppercaseCharacters),
    randomCharacterFrom(passwordDigitCharacters),
    randomCharacterFrom(passwordSpecialCharacters),
  ]

  while (characters.length < 12) {
    characters.push(randomCharacterFrom(passwordAllCharacters))
  }

  return shuffleCharacters(characters).join('')
}
